import React, {useState} from 'react';

import Button from 'js/components/button';
import WorkflowPanel from 'js/components/workflow_panel';
import {EditRequestsForm} from '../../../edit_requests_form';

import './index.scss';
import {EditRequestsFormInternal} from '../../../edit_requests_form_internal';

export default function RejectionRestrictedApproval({
    onApprove,
    onDoNotDistribute,
    onRequestSubmit,
    onInternalMessageSubmit,
    isTransmitting,
    editRequest,
    internalMessages,
    brandEmails,
    isEditsAllowed
}) {
    const [toggleForm, setToggleForm] = useState(false);

    function handleRequestEditClick() {
        setToggleForm(!toggleForm);
    }

    const showEditRequest = !!isEditsAllowed && (editRequest || toggleForm);

    const buttons = [
        <Button
            bigtext
            notransform
            bold
            key="do-not-distribute"
            onClick={onDoNotDistribute}
            disabled={isTransmitting}
            className="no-missed-guidelines-approve-or-do-not-post__button"
        >
            Do Not Post
        </Button>,
        !!isEditsAllowed && (
            <Button
                onClick={handleRequestEditClick}
                disabled={isTransmitting}
                bigtext
                notransform
                key="feedback"
            >
                Leave Feedback
            </Button>
        ),
        <Button
            primary
            bigtext
            notransform
            key="approve"
            onClick={onApprove}
            disabled={isTransmitting}
        >
            Approve To Post
        </Button>
    ];

    return showEditRequest ? (
        <WorkflowPanel className="no-missed-guidelines-approve-or-do-not-distribute" buttons={[]}>
            <>
                <EditRequestsFormInternal
                    onCancel={handleRequestEditClick}
                    onInternalMessageSubmit={onInternalMessageSubmit}
                    internalMessages={internalMessages}
                />
                <EditRequestsForm
                    onCancel={handleRequestEditClick}
                    onRequestSubmit={onRequestSubmit}
                    brandEmails={brandEmails}
                    editRequest={editRequest}
                />
            </>
        </WorkflowPanel>
    ) : (
        <>
            <div className="no-missed-guidelines-approve-or-do-not-distribute__container">
                <div className="no-missed-guidelines-approve-or-do-not-distribute__container-arrow">
                    <span></span>
                </div>
                <p>
                    Select &quot;Approve to Post&quot; and the creator will be notified that they
                    are approved to post their content on their channel.
                </p>
                <ul className="no-missed-guidelines-approve-or-do-not-distribute__start-posting-list">
                    <li>
                        <p>
                            If you select &quot;Do Not Post&quot;, please note that the content will
                            still count towards your campaign total but will not be posted to the
                            creator&apos;s channel.
                        </p>
                    </li>

                    <li>
                        <p>
                            If edit requests are enabled on your account and you want the creator to
                            revise the content, click on &quot;Leave Feedback&quot; to provide the
                            necessary edit details.
                        </p>
                    </li>

                    <li>
                        <p>
                            If you do not feel that the content met all the guidelines and should
                            not have been approved, please email your Account Manager before taking
                            any further actions on this piece of content.
                        </p>
                    </li>
                </ul>
            </div>
            <div className="no-missed-guidelines-approve-or-do-not-distribute__button-container">
                {buttons}
            </div>
        </>
    );
}



// WEBPACK FOOTER //
// ./components/content_review_workflow/rejection_restricted_path/rejection_restricted_approval/index.js